<script setup>
// §8.2 Skeleton — loading placeholder. Shimmer respects prefers-reduced-motion
// (killed globally in base.css). Decorative only — carries no text, no colour
// meaning.
defineProps({
  w: { type: String, default: '100%' },
  h: { type: String, default: '13px' },
  radius: { type: String, default: 'var(--r-sm)' },
})
</script>

<template>
  <span class="l-skeleton" :style="{ width: w, height: h, borderRadius: radius }" aria-hidden="true" />
</template>

<style scoped>
.l-skeleton {
  display: block;
  background: linear-gradient(
    90deg,
    var(--surface-sunken) 0%,
    var(--line-soft) 50%,
    var(--surface-sunken) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.4s var(--ease) infinite;
}
@keyframes shimmer {
  to {
    background-position: -200% 0;
  }
}
</style>
